import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import BillUpdateModalUI from './BillUpdateModalUI.js'

class BillUpdateModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      // form events
      submitted: false,
      // form field
      vendorDocumentRef: this.props.bill && this.props.bill.vendorDocumentRef || '',
      vendorDocumentRefError: null,
      itemSpec: this.props.bill && this.props.bill.itemSpec || '',
      itemSpecError: null,
    }
  }

  render() {
    return (
      <BillUpdateModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelClick}
        // form fields
        vendorDocumentRef={this.state.vendorDocumentRef}
        onVendorDocumentRefChange={(event) => { this.setState({ vendorDocumentRef: event.target.value }) }}
        vendorDocumentRefError={this.state.vendorDocumentRefError}
        setVendorDocumentRefError={(error) => { this.setState({ vendorDocumentRefError: error }) }}
        //
        itemSpec={this.state.itemSpec}
        onItemSpecChange={(event) => { this.setState({ itemSpec: event.target.value }) }}
        itemSpecError={this.state.itemSpecError}
        setItemSpecError={(error) => { this.setState({ itemSpecError: error }) }}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
  }

  componentDidUpdate(prevProps) {
    if (this.props.selectedBill == null)
      return
    if (prevProps.selectedBillId === this.props.selectedBillId)
      return
    this.setState({
      vendorDocumentRef: this.props.selectedBill.vendorDocumentRef || '',
      itemSpec: this.props.selectedBill.itemSpec || '',
    })
  }

  onSubmit = (event) => {
    let submitted = this.state.submitted
    if (submitted)
      return
    let vendorBillId = this.props.selectedBillId
    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.put(this.props.context,
      `/api/su/vendorBills/${vendorBillId}`,
      this.onSubmitCallback, {
      vendorDocumentRef: this.state.vendorDocumentRef,
      itemSpec: this.state.itemSpec,
    }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onRefreshClick()
        this.props.onCancelClick()
      }, 1000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default withRouter(BillUpdateModalSF)
